import React from 'react';
import styles from './InputLabel.module.scss';
function InputLabel({ htmlFor, text }) {
    return (React.createElement("label", { htmlFor: htmlFor, className: styles.wrap }, text));
}
export default InputLabel;
